import styled from "styled-components"

export const StyledScanningLoading = styled.div`
  z-index: 100;
  width: 100%;
  background: #fff;
  bottom: 0;

  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  gap: 16px;
`
export const ScanningText = styled.div`
  /* Base text styling */
  font-size: 16px;
  font-weight: 400;
  color: #474747;
  position: relative;

  /* Background gradient - light shine sweeping across dark text */
  background: linear-gradient(
    115deg,
    #474747 0%,
    rgba(71, 71, 71, 0.95) 15%,
    rgba(71, 71, 71, 0.85) 20%,
    rgba(71, 71, 71, 0.7) 25%,
    rgba(71, 71, 71, 0.5) 30%,
    rgba(57, 57, 57, 0.2) 40%,
    rgba(71, 71, 71, 0.5) 50%,
    rgba(71, 71, 71, 0.7) 55%,
    rgba(71, 71, 71, 0.85) 60%,
    rgba(71, 71, 71, 0.95) 65%,
    #474747 75%,
    #474747 100%
  );
  /* Make background larger than text for animation */
  background-size: 500% 100%;

  /* Clip background to text only */

  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
  width: max-content;

  /* Animation */
  animation: slide-background 2s ease-out infinite;

  @keyframes slide-background {
    0% {
      background-position: 100% 0%;
    }

    100% {
      background-position: 0% 0%;
    }
  }
`
